import { render, staticRenderFns } from "./ModalApproveOnboarding.vue?vue&type=template&id=44dacbce&scoped=true&"
import script from "./ModalApproveOnboarding.vue?vue&type=script&lang=ts&"
export * from "./ModalApproveOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./ModalApproveOnboarding.vue?vue&type=style&index=0&id=44dacbce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dacbce",
  null
  
)

export default component.exports